import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Company Info */}
        <div className="footer-section">
          <h4>Disclaimer</h4>

        <p>
  Embarque Services is an <strong>Independent Multi-Brand Home Appliance Repair Service Provider</strong>.
  We are not an authorized service center or affiliated with any appliance
  manufacturer unless explicitly stated.
</p>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h4>Contact Us</h4>

          <p>
           
 90/48 HEERA NAGAR THOPPUCOLONY, 
 <br/>Madurai, 
  <br />
  Madurai ,<br/>Madurai South
    <br />
 625001
</p>

{/* <p>
  <strong>GSTIN:</strong> 33AEPPI2648K2Z7
</p> */}
<p>
  <a href="tel:+919363929984">
    +91 93639 29984
  </a>
</p>
          <p>
            <a href="mailto:embarque.ads@gmail.com">
              embarque.ads@gmail.com
            </a>
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>

          <ul>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>

            <li>
              <Link to="/terms-condition">Terms & Conditions</Link>
            </li>

              <li>
      <Link to="/refund-policy">Refund Policy</Link>
    </li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <p>
          © 2026 Embarque Services. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;